module.exports = __webpack_public_path__ + "static/media/party-catering-2.8ce47e2a.jpg";